<script setup lang="ts">
interface TProps {
  text: string
}

const props = withDefaults(defineProps<TProps>(), {
  text: `${config.copyright.year} ${config.copyright.company}. All rights reserved.`,
})

const cssClass = computed(() => {
  const result = ['text-xs leading-5']

  return [...new Set(result)].join(' ').trim()
})
</script>

<template>
  <p :class="cssClass">&copy; {{ text }}</p>
</template>
